import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Skeleton, IconButton, Grid } from "@mui/material";
import Container from "@mui/material/Container";
import Badge from "@mui/material/Badge";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

import styles from "./header.module.css";
import logo from "assets/images/ZazooLogo.svg";
import Avatar from "../Avatar";
import { appRoutes } from "utils/helpers";
import { useGetProfileQuery } from "redux/profile/profileSliceV2";
import {
  goBackSettings,
  toggleSettingsMobile,
} from "redux/profile/profileSlice";
import useStyles from "./styles";

export function Header({ isAuthScreen = false }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");
  const tokenZiyl = localStorage.getItem("token_ziyl");
  const auth = useSelector((state) => state.auth.data);

  const classes = useStyles();

  const {
    isUninitialized: isUninitializedProfile,
    isLoading: isLoadingProfile,
    data: profileDetailsData,
  } = useGetProfileQuery({
    skip: !accessToken && !tokenZiyl,
  });
  const unreadMessages =
    profileDetailsData?.userProfile?.totalNotificationsUnread || "";

  return (
    <div id={styles.logo}>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <img
            className={styles.logoImage}
            src={logo}
            alt="zazoo company logo"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(appRoutes.dashboard)}
          />
          <Grid
            item
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {auth?.access_token && (
              <>
                {isUninitializedProfile && isLoadingProfile ? (
                  <div>
                    <Skeleton variant="circular" width={40} height={40} />
                  </div>
                ) : (
                  <Grid
                    container
                    item
                    spacing={1}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item>
                      <IconButton
                        classes={{ root: classes.iconButtonRoot }}
                        onClick={() => {
                          navigate("/dashboard/profile", {
                            state: { tab: "notifications" },
                          });
                        }}
                      >
                        <Badge
                          badgeContent={unreadMessages}
                          invisible={unreadMessages < 1 ? true : false}
                          classes={{ badge: classes.badgeRoot }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                        >
                          <NotificationsOutlinedIcon
                            classes={{ root: classes.iconRoot }}
                          />
                        </Badge>
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <div onClick={() => dispatch(toggleSettingsMobile())}>
                        <Avatar
                          isBase64Image
                          src={profileDetailsData?.userProfile?.profileimage}
                        />
                      </div>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
